type UserDropdownItemProps = {
  name: string;
  role: string;
};

const UserDropdownItem: React.FC<UserDropdownItemProps> = ({ name, role }) => {
  return (
    <div className="flex items-center p-2">
      {" "}
      {/* Removed hover/cursor styles as they'll be on the wrapper */}
      {/* Avatar */}
      <div className="flex-shrink-0 w-10 h-10 rounded-full overflow-hidden bg-gray-200 mr-3">
        <div className="flex items-center justify-center w-full h-full text-gray-500 text-sm">
          {name.charAt(0)}
        </div>
      </div>
      {/* Text Content */}
      <div>
        <p className="text-gray-800 font-medium text-sm">{name}</p>
        <p className="text-red-600 text-xs">{role}</p>
      </div>
    </div>
  );
};

export default UserDropdownItem;

